var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "union-dashboard" },
    [
      _c("div", { staticClass: "dashboard-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-button-group",
              [
                _c(
                  "el-button",
                  {
                    attrs: { icon: "el-icon-refresh" },
                    on: { click: _vm.refreshData },
                  },
                  [_vm._v("刷新数据")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { icon: "el-icon-setting" },
                    on: {
                      click: function ($event) {
                        _vm.showSettings = true
                      },
                    },
                  },
                  [_vm._v("设置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("QuickActions", {
        on: {
          "quick-add": _vm.quickAdd,
          "bulk-import": _vm.bulkImport,
          "export-all": _vm.exportAll,
          "view-stats": _vm.viewStats,
          settings: function ($event) {
            _vm.showSettings = true
          },
          help: function ($event) {
            _vm.showHelp = true
          },
        },
      }),
      _vm._v(" "),
      _c("SyncQuickActions", {
        on: { "sync-completed": _vm.handleSyncCompleted },
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "statistics-overview", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c(
              "div",
              {
                staticClass: "overview-card unions-card",
                on: { click: _vm.goToUnions },
              },
              [
                _c("div", { staticClass: "card-icon" }, [
                  _c("i", { staticClass: "el-icon-office-building" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-number" }, [
                    _vm._v(_vm._s(_vm.overviewData.totalUnions)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("工会总数"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-change",
                      class: { positive: _vm.overviewData.unionChange > 0 },
                    },
                    [
                      _c("i", {
                        class:
                          _vm.overviewData.unionChange > 0
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(Math.abs(_vm.overviewData.unionChange)) +
                          "%\n          "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c(
              "div",
              {
                staticClass: "overview-card members-card",
                on: { click: _vm.goToMembers },
              },
              [
                _c("div", { staticClass: "card-icon" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-number" }, [
                    _vm._v(_vm._s(_vm.overviewData.totalMembers)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("会员总数"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-change",
                      class: { positive: _vm.overviewData.memberChange > 0 },
                    },
                    [
                      _c("i", {
                        class:
                          _vm.overviewData.memberChange > 0
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(Math.abs(_vm.overviewData.memberChange)) +
                          "%\n          "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "overview-card active-card" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "el-icon-check" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "card-number" }, [
                  _vm._v(_vm._s(_vm.overviewData.activeUnions)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-title" }, [_vm._v("活跃工会")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-subtitle" }, [
                  _vm._v("本月活跃"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "overview-card discount-card" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "el-icon-price-tag" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "card-number" }, [
                  _vm._v(_vm._s(_vm.overviewData.discountUnions)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-title" }, [_vm._v("折扣工会")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-subtitle" }, [
                  _vm._v("已开启折扣"),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("UnionChart", { attrs: { data: _vm.chartData } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "recent-activities" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [_vm._v("最近活动")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.viewAllActivities },
                      },
                      [_vm._v("查看全部")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "activity-list" },
                  _vm._l(_vm.recentActivities, function (activity) {
                    return _c(
                      "div",
                      { key: activity.id, staticClass: "activity-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "activity-icon",
                            class: activity.type,
                          },
                          [
                            _c("i", {
                              class: _vm.getActivityIcon(activity.type),
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "activity-content" }, [
                          _c("div", { staticClass: "activity-title" }, [
                            _vm._v(_vm._s(activity.title)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "activity-time" }, [
                            _vm._v(_vm._s(activity.time)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "top-unions" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [_vm._v("活跃工会排行")]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: { change: _vm.updateRanking },
                        model: {
                          value: _vm.rankingType,
                          callback: function ($$v) {
                            _vm.rankingType = $$v
                          },
                          expression: "rankingType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "会员数量", value: "members" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "活跃度", value: "activity" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "增长率", value: "growth" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ranking-list" },
                  _vm._l(_vm.topUnions, function (union, index) {
                    return _c(
                      "div",
                      { key: union.id, staticClass: "ranking-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ranking-position",
                            class: {
                              gold: index === 0,
                              silver: index === 1,
                              bronze: index === 2,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(index + 1) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ranking-content" }, [
                          _c("div", { staticClass: "union-name" }, [
                            _vm._v(_vm._s(union.name)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "union-stats" }, [
                            _vm._v(_vm._s(union.memberCount) + " 名会员"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ranking-score" }, [
                          _vm._v(_vm._s(union.score)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "系统设置",
            visible: _vm.showSettings,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSettings = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "自动刷新" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.settings.autoRefresh,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "autoRefresh", $$v)
                      },
                      expression: "settings.autoRefresh",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "刷新间隔" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: !_vm.settings.autoRefresh },
                      model: {
                        value: _vm.settings.refreshInterval,
                        callback: function ($$v) {
                          _vm.$set(_vm.settings, "refreshInterval", $$v)
                        },
                        expression: "settings.refreshInterval",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "30秒", value: 30 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "1分钟", value: 60 } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "5分钟", value: 300 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "10分钟", value: 600 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "默认页面大小" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.settings.pageSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.settings, "pageSize", $$v)
                        },
                        expression: "settings.pageSize",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "10条/页", value: 10 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "20条/页", value: 20 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "50条/页", value: 50 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "100条/页", value: 100 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showSettings = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveSettings } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "使用帮助", visible: _vm.showHelp, width: "800px" },
          on: {
            "update:visible": function ($event) {
              _vm.showHelp = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "help-content" },
            [
              _c(
                "el-steps",
                { attrs: { active: _vm.helpStep, direction: "vertical" } },
                [
                  _c("el-step", {
                    attrs: {
                      title: "新增工会",
                      description:
                        "点击新增按钮，填写工会基本信息，上传相关证照",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: {
                      title: "管理会员",
                      description: "在工会列表中点击会员按钮，进入会员管理页面",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: {
                      title: "批量操作",
                      description: "使用导入功能批量添加会员，或批量导出数据",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: {
                      title: "数据统计",
                      description: "查看统计图表，了解工会发展趋势",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showHelp = false
                    },
                  },
                },
                [_vm._v("知道了")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-left" }, [
      _c("h2", [_vm._v("工会管理中心")]),
      _vm._v(" "),
      _c("p", [_vm._v("统一管理工会信息和会员数据")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }